// extracted by mini-css-extract-plugin
var _1 = "CancelSoldSubscriptionDialog_booking__xVG-u";
var _2 = "CancelSoldSubscriptionDialog_bookingsList__Rzzr+";
export { _1 as "booking", _2 as "bookingsList" }
